import { modalReceiptHistoryStore } from '@/utils/store-accessor'

export class ModalReceiptHistoryService {
  public open() {
    modalReceiptHistoryStore.open()
  }
}
